var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useMemo } from 'react';
import { CFButton } from '../../components';
import { commonAttrs } from '../../utils';
export const CFListItemButton = (_a) => {
    var { alignment = 'spread', alternateTheme, children, href, iconLeft, iconRight = 'chevron-small-right', onClick, rounded = true, size, variant = 'default', widthPreset = 'full' } = _a, rest = __rest(_a, ["alignment", "alternateTheme", "children", "href", "iconLeft", "iconRight", "onClick", "rounded", "size", "variant", "widthPreset"]);
    const variantStr = useMemo(() => {
        if (alternateTheme)
            return 'control-alternate';
        if (variant === 'subtle')
            return 'subtle-warm';
        return 'control';
    }, [variant, alternateTheme]);
    return (React.createElement(CFButton, Object.assign({ alignment: alignment, href: href, iconLeft: iconLeft, iconRight: iconRight, onClick: onClick, rounded: rounded, size: size, variant: variantStr, widthPreset: widthPreset }, commonAttrs(rest)), children));
};
